import React from "react";

import { Box } from "~components/Box";
import { ButtonLink } from "~components/ButtonLink";

import { type MobileFooter } from "~sections/Nav/Nav.types";

interface FooterProps extends MobileFooter {}

export function Footer({
  buttonLink,
  buttonText,
  secondaryButtonText,
  secondaryButtonLink,
}: FooterProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="spacing2"
      alignItems="center"
    >
      <ButtonLink
        link={secondaryButtonLink}
        appearance="secondary"
        minWidth="100%"
        isCentered
        size="lg"
        shouldHaveArrowIcon={false}
      >
        {secondaryButtonText}
      </ButtonLink>
      <ButtonLink
        link={buttonLink}
        color="ui_primary_base"
        appearance="primary"
        minWidth="100%"
        isCentered
        size="lg"
      >
        {buttonText}
      </ButtonLink>
    </Box>
  );
}
